import { render, staticRenderFns } from "./RecoverPasswordContainer.vue?vue&type=template&id=b5ff63de&scoped=true"
import script from "./RecoverPasswordContainer.vue?vue&type=script&lang=js"
export * from "./RecoverPasswordContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5ff63de",
  null
  
)

export default component.exports